const cookiesEnabledCheck = function cookiesEnabledCheck() {
    let cookiesEnabled = false;

    if (navigator && navigator.cookieEnabled) {
        return true;
    }

    try {
        document.cookie = 'cookietest=1';
        cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    } catch(e) {
        console.warn(`Cookies aren't enabled on this browser.`);
    }

    return cookiesEnabled;
}

export default cookiesEnabledCheck;